import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import "./EditEventType.css";

const EditEventType = () => {
    const [eventTypeName, setEventTypeName] = useState("");
    const [eventTime, setEventTime] = useState<number>(0);
    const [eventColor, setEventColor] = useState("#222222");
    const [TypeId, setTypeId] = useState<number>(0);
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const storedEventName = sessionStorage.getItem("editEventName");

    useEffect(() => {
        const fetchEventDetails = async () => {
            if (!storedEventName) {
                console.error("Brak nazwy wydarzenia w sessionStorage.");
                return;
            }
            try {
                const response = await axiosPrivate.get(`/eventsType/name/${storedEventName}`);
                if (response.data.length > 0) {
                    setEventTypeName(response.data[0].nazwa);
                    setEventTime(response.data[0].czasTrwania);
                    setEventColor(response.data[0].kolor);
                    setTypeId(response.data[0].id)
                } else {
                    console.error("Brak danych dla podanego wydarzenia.");
                    
                }
            } catch (error) {
                console.error("Błąd podczas pobierania szczegółów wydarzenia:", error);
                navigate("/otherList");
            }
        };

        fetchEventDetails();
    }, [axiosPrivate, navigate, storedEventName]);

    const handleSave = async () => {
        if (!storedEventName) {
            console.error("Brak nazwy wydarzenia w sessionStorage.");
            return;
        }
        
        const hexColorRegex = /^#[0-9A-Fa-f]{6}$/;
        if (!hexColorRegex.test(eventColor)) {
            alert("Wprowadź poprawny kolor w formacie #RRGGBB");
            return;
        }
        
        try {
            await axiosPrivate.put(`/eventsType/${storedEventName}`, {
                nazwa: eventTypeName,
                czasTrwania: eventTime,
                kolor: eventColor,
            });
            sessionStorage.removeItem("editEventName");
            navigate(-1);
        } catch (error) {
            console.error("Błąd podczas zapisywania zmian:", error);
        }
        
        sessionStorage.removeItem("editEventName");
    };
    
    

    const handleBack = () => {
        sessionStorage.removeItem("editEventName");
        navigate(-1);
    };

    return (
        <div className="edit-event-container">
            <h3 className="edit-event-title">Edytuj wydarzenie</h3>
            <div className="edit-form-container">
                <div className="edit-row">
                    <div className="edit-form-group">
                        <label>Nazwa wydarzenia</label>
                        <input
                            type="text"
                            value={eventTypeName}
                            onChange={(e) => setEventTypeName(e.target.value)}
                            className="edit-input"
                        />
                    </div>
                    <div className="edit-form-group">
                        <label>Przewidywany czas trwania</label>
                        <input
                            type="number"
                            value={eventTime}
                            onChange={(e) => setEventTime(Number(e.target.value))}
                            className="edit-input"
                        />
                    </div>
                </div>
                <div className="edit-row">
                    <div className="edit-form-group">
                        <label>Wybierz kolor</label>
                        <input
                            type="text"
                            value={eventColor}
                            onChange={(e) => setEventColor(e.target.value)}
                            className="edit-input"
                            pattern="^#[0-9a-fA-F]{6}$"
                            title="Wprowadź kolor w formacie #RRGGBB"
                        />
                    </div>
                    <div className="edit-form-group">
                        <label>Kolor</label>
                        <div
                            className="edit-color-block"
                            style={{ backgroundColor: eventColor || "#222222" }}
                        ></div>
                    </div>
                </div>
            </div>
            <div className="edit-buttons-container">
                <button onClick={handleSave} className="edit-button">Zapisz</button>
                <button onClick={handleBack} className="edit-button edit-cancel-button">Anuluj</button>
            </div>
        </div>
    );
};

export default EditEventType;
